import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    scroll-mt-32
  `,
  slots: {
    container: `
      grid
      transition-[grid-template-rows]
      duration-300
      ease-in-out
    `,
    containerInner: `
      min-h-[--initialHeight]
      overflow-hidden
    `,
    buttonWrapper: `
      mt-2
      flex
      justify-center
    `,
  },
  variants: {
    buttonAside: {
      true: '',
    },
    isOpen: {
      true: {
        container: `grid-rows-[1fr]`,
        buttonWrapper: `
          sticky
          bottom-4
          transition-[position]
          delay-1000
          [&>button]:bg-white
        `,
      },
      false: {
        container: `grid-rows-[0fr]`,
      },
    },
    isButtonSticky: {
      true: {
        buttonWrapper: `
          [&>button]:shadow-md
        `,
      },
    },
  },
  compoundVariants: [
    {
      buttonAside: true,
      isOpen: false,
      class: {
        buttonWrapper: `
          absolute
          bottom-4
          right-4
          bg-[linear-gradient(to_right,transparent,white_28px)]
          pl-10
        `,
      },
    },
  ],
});
